/* ==========================================================================
   wc2-voice.js — お客様の声 ページ専用(素のJS・依存なし)
   --------------------------------------------------------------------------
   このファイルがやることは4つ。

     1. 絞り込み(星4種 × 話題5種)の表示の切り替え
     2. 「もっと見る」で表示する枚数を増やす
     3. 新しい順・評価順の並べ替え
     4. 長文の開閉(各項目3行まで)

   声そのものは Liquid がサーバー側で全件 HTML として出している。
   このファイルはカードを作らない・消さない。`hidden` 属性で表示を切り替え、並べ替え時は既存のカードを移動する。
   したがって JS が動かない環境では、絞り込みと「もっと見る」が出ないかわりに
   全件がそのまま読める。

   計測は dataLayer への push だけ(assets/wc2-color.js と同じ作法)。
   GTM 側の設定はまだ無い。イベント名は wc2_voice_ で始める。
   ========================================================================== */

(function () {
  'use strict';

  var STEP = 9; /* 最初に出す枚数 = 足していく枚数 */

  var STAR_FILTERS = [
    { id: 'all', label: 'すべて', test: function () { return true; } },
    { id: '5', label: '★5', test: function (n) { return n === 5; } },
    { id: '4', label: '★4', test: function (n) { return n === 4; } },
    { id: 'low', label: '★3以下', test: function (n) { return n <= 3; } }
  ];

  var TOPICS = [
    { id: 'finish', label: '仕上がり' },
    { id: 'talk', label: 'やり取り' },
    { id: 'price', label: '金額' },
    { id: 'pack', label: '梱包と配送' },
    { id: 'first', label: 'はじめての注文' }
  ];

  /* ------------------------------------------------------------- 計測 */

  function track(event, payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      var o = { event: event };
      if (payload) {
        for (var k in payload) {
          if (Object.prototype.hasOwnProperty.call(payload, k)) o[k] = payload[k];
        }
      }
      window.dataLayer.push(o);
    } catch (e) {
      /* 計測の失敗でページを止めない */
    }
  }

  /* ------------------------------------------------------------- 部品 */

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined && text !== null) n.textContent = text;
    return n;
  }

  function starFilter(id) {
    for (var i = 0; i < STAR_FILTERS.length; i++) {
      if (STAR_FILTERS[i].id === id) return STAR_FILTERS[i];
    }
    return STAR_FILTERS[0];
  }

  /* --------------------------------------------------------- 1ページぶん */

  function setup(root) {
    if (root.getAttribute('data-wc2-bound') === '1') return;
    root.setAttribute('data-wc2-bound', '1');

    var filters = root.querySelector('[data-wc2-voice-filters]');
    var hostStar = root.querySelector('[data-wc2-voice-star]');
    var hostTopic = root.querySelector('[data-wc2-voice-topic]');
    var cardsHost = root.querySelector('[data-wc2-voice-cards]');
    var moreBtn = root.querySelector('[data-wc2-voice-more]');
    var emptyEl = root.querySelector('[data-wc2-voice-empty]');
    var resultEl = root.querySelector('[data-wc2-voice-result]');

    if (!cardsHost) return;

    var cards = [].slice.call(cardsHost.querySelectorAll('.wc2-voice__card'));
    if (!cards.length) return;

    /* カードの中身は読み込み時に1度だけ読む */
    var items = cards.map(function (node, index) {
      var stars = parseInt(node.getAttribute('data-stars'), 10);
      var topics = (node.getAttribute('data-topics') || '').split(/\s+/).filter(Boolean);
      return { order: index, node: node, stars: isNaN(stars) ? 0 : stars, topics: topics };
    });

    /* 本文は書き換えず、各項目を3行まで表示。JSなしでは全文が読める。 */
    var disclosureItems = cards.map(function (card, index) {
      var paragraphs = [].slice.call(card.querySelectorAll('.wc2-voice__cseg-tx, .wc2-voice__creply-tx'));
      var ids = paragraphs.map(function (paragraph, part) {
        paragraph.id = (root.parentElement.id || 'wc2-voice') + '-review-' + index + '-' + part;
        return paragraph.id;
      });
      var button = el('button', 'wc2-voice__readmore', '続きを読む');
      button.type = 'button';
      button.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-controls', ids.join(' '));
      button.addEventListener('click', function () {
        var expanded = button.getAttribute('aria-expanded') !== 'true';
        card.classList.toggle('is-expanded', expanded);
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? '閉じる' : '続きを読む';
        if (!expanded && button.getBoundingClientRect().top < 0) {
          button.scrollIntoView({ block: 'center', behavior: 'auto' });
        }
      });
      card.appendChild(button);
      return { card: card, paragraphs: paragraphs, button: button };
    });

    function measureDisclosures() {
      disclosureItems.forEach(function (item) {
        if (item.card.hidden || !item.card.getBoundingClientRect().width) return;
        var long = item.paragraphs.some(function (p) {
          return p.scrollHeight > parseFloat(window.getComputedStyle(p).lineHeight) * 3 + 1;
        });
        item.card.classList.toggle('is-collapsible', long);
        item.button.hidden = !long;
        if (!long) {
          item.card.classList.remove('is-expanded');
          item.button.setAttribute('aria-expanded', 'false');
          item.button.textContent = '続きを読む';
        }
      });
    }
    var disclosureFrame = 0;
    function scheduleDisclosures() {
      if (disclosureFrame) cancelAnimationFrame(disclosureFrame);
      disclosureFrame = requestAnimationFrame(function () {
        disclosureFrame = 0;
        measureDisclosures();
      });
    }
    window.addEventListener('resize', scheduleDisclosures);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleDisclosures);

    var state = { star: 'all', topic: 'all', shown: STEP };

    function matches(item, starId, topicId) {
      if (!starFilter(starId).test(item.stars)) return false;
      if (topicId !== 'all' && item.topics.indexOf(topicId) === -1) return false;
      return true;
    }

    function countFor(starId, topicId) {
      var n = 0;
      for (var i = 0; i < items.length; i++) {
        if (matches(items[i], starId, topicId)) n++;
      }
      return n;
    }

    function makePill(label, count, pressed, onClick) {
      var b = el('button', 'wc2-voice__pill');
      b.type = 'button';
      b.setAttribute('aria-pressed', pressed ? 'true' : 'false');
      b.appendChild(document.createTextNode(label));
      b.appendChild(el('span', 'wc2-voice__pill-n', String(count)));
      b.addEventListener('click', onClick);
      return b;
    }

    function renderFilters() {
      if (!hostStar || !hostTopic) return;
      hostStar.textContent = '';
      hostTopic.textContent = '';

      STAR_FILTERS.forEach(function (s) {
        hostStar.appendChild(makePill(
          s.label, countFor(s.id, state.topic), state.star === s.id,
          function () {
            state.star = s.id;
            state.shown = STEP;
            render();
            track('wc2_voice_filtered', { method: 'star', value: s.id, shown: shownCount() });
          }
        ));
      });

      hostTopic.appendChild(makePill(
        'すべて', countFor(state.star, 'all'), state.topic === 'all',
        function () {
          state.topic = 'all';
          state.shown = STEP;
          render();
          track('wc2_voice_filtered', { method: 'topic', value: 'all', shown: shownCount() });
        }
      ));
      TOPICS.forEach(function (t) {
        hostTopic.appendChild(makePill(
          t.label, countFor(state.star, t.id), state.topic === t.id,
          function () {
            state.topic = t.id;
            state.shown = STEP;
            render();
            track('wc2_voice_filtered', { method: 'topic', value: t.id, shown: shownCount() });
          }
        ));
      });
    }

    function shownCount() {
      var n = 0;
      for (var i = 0; i < items.length; i++) {
        if (!items[i].node.hidden) n++;
      }
      return n;
    }

    function renderCards() {
      var total = 0;
      var visible = 0;
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (matches(it, state.star, state.topic)) {
          total++;
          if (visible < state.shown) {
            it.node.hidden = false;
            visible++;
          } else {
            it.node.hidden = true;
          }
        } else {
          it.node.hidden = true;
        }
      }

      scheduleDisclosures();
      if (emptyEl) emptyEl.hidden = total !== 0;

      var rest = total - visible;
      if (moreBtn) {
        moreBtn.hidden = rest <= 0;
        moreBtn.textContent = 'もっと見る（あと' + rest + '件）';
      }
      if (resultEl) {
        resultEl.hidden = false;
        resultEl.textContent = total === 0
          ? '0件'
          : '全' + total + '件のうち ' + visible + '件を表示しています';
      }
    }

    function render() {
      renderFilters();
      renderCards();
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        state.shown += STEP;
        renderCards();
        track('wc2_voice_more', { shown: shownCount(), star: state.star, topic: state.topic });
      });
    }

    var sortSelect = root.querySelector('[data-wc2-voice-sort]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var mode = sortSelect.value;
        items.sort(function (a, b) {
          var delta = mode === 'low' ? a.stars - b.stars : mode === 'high' ? b.stars - a.stars : 0;
          return delta || a.order - b.order;
        });
        items.forEach(function (item) { cardsHost.appendChild(item.node); });
        state.shown = STEP;
        renderCards();
      });
    }

    /* 料金ページへのリンク */
    [].slice.call(root.querySelectorAll('[data-wc2-voice-link]')).forEach(function (a) {
      a.addEventListener('click', function () {
        track('wc2_voice_price_link', { step: a.getAttribute('data-wc2-voice-link') });
      });
    });

    /* ここまで来たら JS は動いている。絞り込みと「もっと見る」を出す。 */
    if (filters) filters.hidden = false;
    render();
  }

  function init() {
    try {
      [].slice.call(document.querySelectorAll('[data-wc2-voice]')).forEach(setup);
    } catch (e) {
      /* 失敗したら全件が出たままにする(畳まない) */
      [].slice.call(document.querySelectorAll('.wc2-voice__card')).forEach(function (n) {
        n.hidden = false;
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* テーマエディタでセクションを入れ直したとき */
  document.addEventListener('shopify:section:load', init);
})();
